import { Icon, ICONS, TreeSelect } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { ReactElement, useEffect, useState } from 'react';
import { Popup } from 'semantic-ui-react';
import styles from './InterestSelector.module.scss';

const cx = classNames.bind(styles);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function InterestSelector({ sectors, selectedTags, onChange }): ReactElement {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    const array = sectors.map((sector: any) => {
      return {
        key: sector.tagId,
        title: sector.displayName,
        children: sector.childSectors.map((child) => {
          return {
            key: child.tagId,
            title: child.displayName,
          };
        }),
      };
    });

    setData(array);
  }, [sectors]);

  const handleUpdates = (tags) => {
    onChange(tags);
  };

  return (
    <Popup
      className={cx('body')}
      basic
      trigger={
        <div className={cx('trigger-ctx')}>
          <Icon name={ICONS.CaretDown} height={14} />
        </div>
      }
      closeOnEscape
      position="bottom right"
      on="click"
      offset={[10, 8]}
      pinned
    >
      <TreeSelect data={data} checkedKeys={selectedTags} treeHeight={256} setCheckedKeys={(items) => handleUpdates(items)} />
    </Popup>
  );
}

export default InterestSelector;
